import * as sdpTransform from 'sdp-transform';
const summarizeMedia = (media) => {
    // `sdp-transform` parses a numeric `a=mid` as a number and leaves `type`
    // unset on a malformed `m=` line, despite its declared types.
    const mid = media.mid;
    const kind = media.type;
    return {
        ...(mid === undefined ? {} : { mid: String(mid) }),
        kind: typeof kind === 'string' ? kind : 'unknown',
        ...(media.direction ? { direction: media.direction } : {}),
        ...(media.content ? { content: media.content } : {}),
        codecs: [...new Set(media.rtp.map(({ codec }) => codec))],
    };
};
/**
 * Summarizes a session description for routine logs. Log the description
 * itself only at a detailed level, where log redaction masks its credentials.
 *
 * @example
 * summarizeSessionDescription({type: 'offer', sdp});
 * // {type: 'offer', media: [{mid: '0', kind: 'audio', direction: 'sendrecv', codecs: ['opus']}]}
 */
export const summarizeSessionDescription = (description) => ({
    ...(description?.type ? { type: description.type } : {}),
    media: typeof description?.sdp === 'string'
        ? sdpTransform.parse(description.sdp).media.map(summarizeMedia)
        : [],
});
//# sourceMappingURL=sdpSummary.js.map